import React from "react";
import { Toaster as RHTToaster, ToastPosition } from "react-hot-toast";

export const TOAST_POSITION: ToastPosition = "top-right";
export const TOAST_DURATION = 4000;

export function Toaster(options?: React.ComponentProps<typeof RHTToaster>) {
  const appliedToasterOptions = {
    position: TOAST_POSITION,
    ...options,
    toastOptions: {
      duration: TOAST_DURATION,
      ...options?.toastOptions,
    },
  };
  return <RHTToaster {...appliedToasterOptions} />;
}
